import { getPageRoutes } from "@/routes/pageRoutes";
import { useGetAdvertisemnetBannersQuery } from "@/store/services/misc";
import { Box, BoxProps, Heading } from "@chakra-ui/react";
import { AdvetisementSlider } from "@picovico/ui";
import { useRouter } from "next/router";
import React from "react";
export interface AdvertisementProps {
  title?: string;
  titleProps?: React.ComponentProps<typeof Heading>;
  displayTitle?: boolean;
  containerProps?: BoxProps;
}

export function AdvertisementCarousel({
  title,
  titleProps,
  displayTitle = true,
  containerProps,
  ...props
}: AdvertisementProps) {
  const router = useRouter();
  const { data } = useGetAdvertisemnetBannersQuery({});
  const slides =
    data?.data?.map((item) => ({
      image: item.image,
      alt: item.title,
      onClick: () =>
        router.push(
          getPageRoutes("advertisement_detail", {
            advertisementIdx: item.idx,
          }),
        ),
    })) || [];

  return (
    <>
      {slides.length > 0 && (
        <Box mt="40px" {...containerProps}>
          {displayTitle && (
            <Heading
              textTransform="uppercase"
              fontSize={{ base: "32px" }}
              my="10px"
              {...titleProps}
            >
              {title}
            </Heading>
          )}
          <AdvetisementSlider slides={slides} {...props} />
        </Box>
      )}
    </>
  );
}
